import i18n from 'i18next';

// import getInitiativeTypes from './getInitiativeTypes';

export default () => [
  // {
  //   allow_multiple_selects: true,
  //   key: 'initiative_type',
  //   label: i18n.t('initiative-type'),
  //   options: getInitiativeTypes(),
  // },
  {
    key: 'social_tracking',
    label: i18n.t('social'),
    options: [
      { label: i18n.t('social-tracking-filter-true'), value: true },
      { label: i18n.t('social-tracking-filter-false'), value: false },
    ],
  },
  {
    key: 'ecommerce_tracking',
    label: i18n.t('ecommerce'),
    options: [
      { label: i18n.t('ecommerce-tracking-filter-true'), value: true },
      { label: i18n.t('ecommerce-tracking-filter-false'), value: false },
    ],
  },
  {
    key: 'live_tracking',
    label: i18n.t('instructor-led'),
    options: [
      { label: i18n.t('instructor-led-tracking-filter-true'), value: true },
      { label: i18n.t('instructor-led-tracking-filter-false'), value: false },
    ],
  },
];
